import React from "react";

const Horse = () => {
  return (
    <div className="horse">
      <img
        className="horseimage"
        alt="horse"
        src="/Assets/horse 2 4.webp"
      ></img>
    </div>
  );
};

export default Horse;
